import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { OnGoingAction } from "../../../components/UI/Banner/OnGoingAction";
import React, { Suspense, useEffect } from "react";
import { useUiStore } from "store/zustand-store/uiStore";
import AdminMobileNavbar from "./AdminMobileNavbar";
const NewSideNav = React.lazy(() =>
  import("./Sidebar/new-side-nav").then((mod) => ({
    default: mod.NewSideNav,
  }))
);

export default function AdminLayout() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isSidebarOpen = useUiStore((state) => state.isSidebarOpen);
  const closeSidebar = useUiStore((state) => state.closeSidebar);

  //variables
  const isWorkspace = pathname === "/workspace";
  const isCampaignDetails = /^\/email\/campaigns\/[^/]+$/.test(pathname);
  const isFullBleed = isWorkspace || isCampaignDetails;

  const {
    onGoingEvent,
    eventId,
    teamId,
  } = useSelector((state) => state.onGoingActionSlice);

  useEffect(() => {
    closeSidebar();
  }, [closeSidebar, pathname, searchParams]);

  useEffect(() => {
    document.body.style.overflow = isSidebarOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isSidebarOpen]);

  return (
    <section className="relative min-h-screen bg-white">
      {onGoingEvent && (
        <OnGoingAction
          type={"Event"}
          url={`/active-event/${eventId}/${teamId}?isEvent=${true}`}
        />
      )}
      {isSidebarOpen && (
        <button
          type="button"
          aria-label="Close navigation menu"
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
          onClick={closeSidebar}
        />
      )}
      <section
        className={`fixed inset-y-0 left-0 z-50 w-[min(86vw,320px)] transition-transform duration-300 ease-in-out lg:z-10 lg:w-[18%] lg:translate-x-0 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } `}
      >
        {/* <Sidebar /> */}
        <Suspense fallback={<div style={{ padding: 12 }}>Loading...</div>}>
          <NewSideNav />
        </Suspense>
      </section>

      <section
        className={`min-h-screen w-full bg-white lg:ml-[18%] lg:w-[82%] ${
          isFullBleed ? "py-0" : "px-4 pb-4 pt-20 sm:px-5 lg:py-4"
        }`}
      >
        {!isFullBleed && <AdminMobileNavbar />}
        <Outlet />
      </section>
    </section>
  );
}
